import constant from "../../constant";
import axios from "axios";
import router from "../../router";
import { printData } from "../../utils/printUtils";
const api = constant.api + "items";
// initial state
const state = () => ({
  all: [],
  items: [],
  item: {},
  itemTransactions: [],
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getItem: (state) => {
    return state.item;
  },

  getItems: (state) => {
    return state.items;
  },

  getItemTransactions: (state) => state.itemTransactions,

  getSalesTotalQuantity: (state) => {
    if (state.itemTransactions.sales) {
      return state.itemTransactions.sales.reduce(
        (acc, val) => acc + parseFloat(val.quantity),
        0
      );
    } else {
      return 0;
    }
  },

  getPurchaseTotalQuantity: (state) => {
    if (state.itemTransactions.purchases) {
      return state.itemTransactions.purchases.reduce(
        (acc, val) => acc + parseFloat(val.quantity),
        0
      );
    } else {
      return 0;
    }
  },
};

// actions
const actions = {
  async getAll({ commit }) {
    const items = await this.$api.fetch(api);
    commit("setItems", items);
  },

  async getItemsPrices({ commit }) {
    const items = await this.$api.fetch(api + "_prices");
    commit("setItemsPrices", items);
  },
  async show({ commit }, reference) {
    const response = await this.$api.show(api + "/" + reference);
    const item = response.data || response;
    commit("setItem", item);
  },

  async store({ dispatch }, data) {
    await this.$api.create(api, data);
  },

  async storeAndRouteToPurchase({ dispatch }, data) {
    const response = await this.$api.create(api, data);
    const itemData = response.data.data || response.data;
    router.push({
      name: "purchases-create",
      query: { item_reference: itemData.reference },
    });
  },

  async storePrice({ commit, dispatch }, data) {
    const response = await this.$api.create(api + "_prices", data, {
      confirm: false,
    });
    if (response.data.status == "success") {
      commit("setItemsPrices", response.data.data);
    }
  },

  async update({ dispatch }, data) {
    // For file uploads, we need to use axios directly with multipart/form-data
    const response = await axios.post(api + "/" + data.get("reference"), data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 30000,
    });

    if (response.data.status == "success") {
      router.push({
        name: "items-index",
      });
    }
  },

  async destroy({ commit, dispatch }, reference) {
    const response = await this.$api.delete(api + "/" + reference);
    if (response.data.status == "success") {
      const items = response.data.data;
      commit("setItems", items);
    }
  },

  async printAll({ dispatch }) {
    // For PDF blob downloads, use axios directly
    const response = await axios.get(api + "_print", {
      responseType: "blob",
      timeout: 30000,
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Catalogue.pdf");
    link.click();
    window.URL.revokeObjectURL(url);
  },

  async generateBarcode({ commit }, reference) {
    const response = await this.$api.create(
      api + "/" + reference + "/generate-barcode",
      {},
      { confirm: false }
    );

    if (response && response.data && response.data.data) {
      commit("setItemBarcode", response.data.data);
    }
  },

  async printBarcode({ dispatch }, reference) {
    await printData([], api + "/" + reference + "/print-barcode", "GET");
  },

  async fetchItemTransactions({ commit }, data) {
    const response = await this.$api.create(api + "_transactions", data, {
      confirm: false,
    });
    commit("setItemTransactions", response.data);
  },
};

// mutations
const mutations = {
  setItems(state, items) {
    state.all = items;
    state.items = items;
  },

  setItemTransactions(state, items) {
    state.all = items;
    state.itemTransactions = items;
  },
  setItemsPrices(state, items) {
    state.all = items;
    state.items = items;
  },
  setItem(state, item) {
    state.item = item;
  },
  setItemBarcode(state, item) {
    state.all = state.all.map((row) =>
      row.reference === item.reference ? { ...row, ...item } : row
    );
    state.items = state.items.map((row) =>
      row.reference === item.reference ? { ...row, ...item } : row
    );

    if (state.item && state.item.reference === item.reference) {
      state.item = { ...state.item, ...item };
    }
  },
  async search(state, value) {
    value = value.charAt(0).toUpperCase() + value.slice(1);
    console.log(value);
    state.items = state.all.filter(function (item) {
      return (
        item.firstName.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        item.lastName.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        item.phone.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        item.reference.toUpperCase().indexOf(value.toUpperCase()) > -1
      );
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
